module.exports = __webpack_public_path__ + "static/offer-d-2-new-2279ef2b53fe8600d9425eb5e59d2881.jpg";